import { Cell } from 'react-table'

import { prettyLicenseDescription } from 'features/licenses/utils'
import type { LicenseType } from 'features/licenses/types'
import {
  LicensingDescriptionContainer,
  LicensingDescriptionLabel,
  LicensingDescriptionTitle,
} from './styles'

function LicensingDescription({
  value,
  row: {
    original: { description },
  },
}: Cell<LicenseType>) {
  return (
    <LicensingDescriptionContainer>
      <LicensingDescriptionTitle>
        {prettyLicenseDescription(description)}
      </LicensingDescriptionTitle>
      <LicensingDescriptionLabel>{value}</LicensingDescriptionLabel>
    </LicensingDescriptionContainer>
  )
}

export default LicensingDescription
